// This is a synchronous action, hence

// thunk will not interfere.
export const resetPersonalizationSettings = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_PERSONALIZATION_SETTINGS", payload: null });
  };
};
export const setPreviewScreenId = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PREVIEW_SCREEN_ID",
      value: value,
    });
  };
};
export const setIsPersonalizationPreviewOpen = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_IS_PERSONALIZATION_PREVIEW_OPEN",
      value: value,
    });
  };
};
export const setSelectedConfigComponent = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_CONFIG_COMPONENT",
      value: value,
    });
  };
};
export const setUpdatedAccentColors = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ACCENT_COLOR",
      value: value,
    });
  };
};
export const togglePersonalisation = (value) => {
  return (dispatch) => {
    dispatch({
      type: "TOGGLE_PERSONALISATION",
      value: value,
    });
  };
};
export const setSameStyleBannerFooter = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SAME_STYLE",
      value: value,
    });
  };
};
export const setBannerFontWeight = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_FONT_WEIGHT",
      value: value,
    });
  };
};
export const setBannerFontSize = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_FONT_SIZE",
      value: value,
    });
  };
};
export const setBannerFontFamily = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_FONT_FAMILY",
      value: value,
    });
  };
};
export const setBannerTextColor = (componentKey, value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_TEXT_COLOR",
      payload: {
        componentKey,
        value,
      },
    });
  };
};
export const setCustomPaletteInfo = (index, componentKey, value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CUSTOM_PALETTE_INFO",
      payload: {
        index,
        componentKey,
        value,
      },
    });
  };
};
export const setDraggedComponentPosition = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DRAGGED_COMPONENT_POSITIONS",
      value: value,
    });
  };
};
export const setSelectedPalette = (index, value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_PALETTE",
      index: index,
      value: value,
    });
  };
};
export const setBannerTextPosition = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_TEXTBOX_POSITION",
      value: value,
    });
  };
};
export const setFooterTextPosition = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_FOOTER_TEXTBOX_POSITION",
      value: value,
    });
  };
};
export const setBannerTitle = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_TITLE",
      value: value,
    });
  };
};
export const setFooterSubtitle = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_FOOTER_SUBTITLE",
      value: value,
    });
  };
};
export const setBannerSubtitle = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_SUBTITLE",
      value: value,
    });
  };
};
export const setComponentBackground = (componentKey, backgroundValue) => ({
  type: "SET_COMPONENT_BACKGROUND",
  payload: {
    componentKey,
    backgroundValue,
  },
});
export const setHeaderAndFooterLayoutConfig = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_HEADER_AND_FOOTER_LAYOUT_CONFIG",
      value: value,
    });
  };
};
export const setBrandUploadLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BRAND_UPLOAD_LOADER",
      value: value,
    });
  };
};
export const setBrandConfig = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BRAND_CONFIG",
      value: value,
    });
  };
};
export const setLogoUrlInBrandConfig = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_LOGO_URL_IN_BRAND_CONFIG",
      url: value,
    });
  };
};
export const setLogoImageUrlInLogosJson = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_LOGO_IMAGE_URL_IN_LOGOS_JSON",
      url: value,
    });
  };
};
export const setBannerImageUrlInLogosJson = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BANNER_IMAGE_URL_IN_LOGOS_JSON",
      url: value,
    });
  };
};
export const setLogoPositionInBrandConfig = (position) => {
  return (dispatch) => {
    dispatch({
      type: "SET_LOGO_POSITION_IN_BRAND_CONFIG",
      position: position,
    });
  };
};
export const setLogoStyleInLocobuzzLogoConfig = (style) => {
  return (dispatch) => {
    dispatch({
      type: "SET_LOGO_STYLE_IN_LOCOBUZZ_CONFIG",
      style: style,
    });
  };
};
export const setLogoPositionInLocobuzzLogoConfig = (position) => {
  return (dispatch) => {
    dispatch({
      type: "SET_LOGO_POSITION_IN_LOCOBUZZ_CONFIG",
      position: position,
    });
  };
};
export const setThemesListInState = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_AVAILABLE_THEMES_DETAILS",
      themeList: value,
    });
  };
};
export const setSelectedThemeState = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SEL_SELECTED_THEME_STATE",
      payload: value,
    });
  };
};
export const resetTheme = (value) => {
  return (dispatch) => {
    dispatch({
      type: "RESET_THEME_STATE",
      payload: value,
    });
  };
};
export const setColorPickerId = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_COLOR_PICKER_ID",
      payload: value,
    });
  };
};
